import TwoColumnLayout from "../Layout/TwoColumnLayout";
import Hero from "../Layout/Hero";
import FormController from "../Layout/FormController";
import FormHenderson from "../Forms/FormHenderson";
import FooterWithCTA from "../Layout/FooterWithCTA";

function PageHenderson(props){
    return <div>
        <TwoColumnLayout>
            <Hero
                backgroundDesktop={"/Henderson/Henderson.png"}
                backgroundMobile={"/Henderson/Henderson-mobile.png"}
            ></Hero>
            <FormController
                devMode={process.env.NODE_ENV === "development"}
                formName={"henderson"}
                form={FormHenderson}
                formHeader={<>
                    <h1 className={"text-3xl text-white font-form"}>Cadillac Iconic Experiences: Play Baltusrol with Brooke Henderson</h1>
                    <p className={"text-white mb-4 mt-2"}>One winner and two guests will win an all-expense paid trip to New Jersey where they'll play Baltusrol Golf Club with two-time major champion Brooke Henderson during the KPMG Women’s PGA Championship Pro-Am.</p>
                </>}
                disclaimerText={<>
                    <p>NO PURCHASE OR PAYMENT NECESSARY TO ENTER OR WIN. Open to legal residents of the 50 U.S./D.C., age 18+. Void where prohibited. Sweepstakes starts at 12:00:01 AM ET on 05/15/23; ends at 11:59:59 PM ET on 06/09/23. Total ARV of all prizes: $30,600. Limit: One (1) Entry per person. For full Official Rules, <a className={"underline"} href={"https://www.pga.com/pga-of-america/cadillac-iconic-experiences-rules"} target={"_blank"} rel={"noreferrer"}>click here</a>. Sponsor: The Professional Golfers’ Association of America, 100 Avenue of the Champions, Palm Beach Gardens, FL 33418.</p>
                </>}
            ></FormController>
        </TwoColumnLayout>
        <FooterWithCTA cta={"Buy Tickets"} href={"https://www.axs.com/festivals/437965"}>
            Stay and  watch the world's best golfers compete for the coveted KPMG Women's PGA Championship title, June 22st - 25th. Tickets start at $25 and range from Single Day General Admission to Single Day Premium Hospitality.  Juniors 17 and under receive complimentary admission with a ticketed adult.
        </FooterWithCTA>
    </div>
}

export default PageHenderson;
